import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 1500 });
  }

  openDeleteDialog(
    componentName: any,
    height: any,
    width: any,
    dataModel: any,
    maxwidth: any
  ) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

  // Bussiness Industry API

  // for Business Industry listing
  getBusinessIndustry(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/count?pageNo=${page}&size=${size}`
    );
  }
  getActiveInActiveIndustryCount() {
    return this.http.get(
      environment.baseUrl + `admin/master/business/industry/active/inactive`
    );
  }
  getAllBusinessIndustry(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry?size=${size}&page=${page}`
    );
  }

  // for Bussiness Industry Search
  getSearchIndustry(page: number, size: number, text: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/search?pageNo=${page}&size=${size}&text=${text}`
    );
  }

  //for add Industry
  addBusinessIndustry(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/business/industry`,
      data
    );
  }

  updateBusinessIndustry(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/industry`,
      data
    );
  }

  changeToggleIndustry(status: any, id: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/industry/status?active=${status}&id=${id}`,
      {}
    );
  }

  industryFilter(status: any, pageNo: any, size: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/industry/filter?active=${status}&pageNo=${pageNo}&size=${size}`,
      {}
    );
  }
  // Delete Business Industry API
  deleteIndustry(industryId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/master/business/industry?id=${industryId}`
    );
  }

  // Sub Industry API
  // for sub industry Listing api
  getSubIndustries(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/sub/count?pageNo=${page}&size=${size}`
    );
  }
  getSubIndustriesForComponent(size: number, page: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/sub?size=${size}&page=${page}`
    );
  }

  // for Bussiness Industry Search
  getSearchSubIndustry(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/sub/search?pageNo=${page}&size=${size}&text=${searchText}`
    );
  }
  getActiveInActiveSubIndustryCount() {
    return this.http.get(
      environment.baseUrl + `admin/master/business/sub/industry/active/inactive`
    );
  }
  //for add Sub Industry
  addBusinessSubIndustry(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/business/industry/sub`,
      data
    );
  }

  updateBusinessSubIndustry(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/industry/sub`,
      data
    );
  }

  getSubIndustryByIndustry(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/industry/sub/list`,
      data
    );
  }
  deleteSubIndustry(subIndustryId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/master/business/sub?id=${subIndustryId}`
    );
  }

  changeToggleSubIndustry(status: any, id: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/sub/status?active=${status}&id=${id}`,
      {}
    );
  }

  subIndustryFilter(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/sub/filter`,
      data
    );
  }

  // Business Type API

  getBusinessType(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/type/count?pageNo=${page}&size=${size}`
    );
  }

  // for Bussiness type Search
  getSearchType(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/type/search?pageNo=${page}&size=${size}&text=${searchText}`
    );
  }
  getActiveInActiveBusinessTypeCount() {
    return this.http.get(
      environment.baseUrl + `admin/master/business/bus/type/active/inactive`
    );
  }
  // for add bussines type
  addBusinessType(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/business/type`,
      data
    );
  }

  // for add bussines type
  updateBusinessType(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/type`,
      data
    );
  }

  // Delete Business Type API
  deleteType(typeId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/master/business/type?id=${typeId}`
    );
  }
  changeToggleBusinessType(status: any, id: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/type/status?isActive=${status}&id=${id}`,
      {}
    );
  }

  businessTypeFilter(status: any, pageNo: any, size: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/type/filter?active=${status}&pageNo=${pageNo}&size=${size}`,
      {}
    );
  }

  // Registration business API
  // for listing

  getRegistrationListing(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/registration/count?pageNo=${page}&size=${size}`
    );
  }
  getActiveInActiveRegistrationTypeCount() {
    return this.http.get(
      environment.baseUrl + `admin/master/business/Reg/type/active/inactive`
    );
  }
  // for search
  getSearchRegistration(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/registration/search?pageNo=${page}&size=${size}&text=${searchText}`
    );
  }
  changeToggleRegistrationType(status: any, id: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/registration/status?active=${status}&id=${id}`,
      {}
    );
  }

  // for add registration business type

  addRegistrationType(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/business/registration`,
      data
    );
  }
  updateRegistrationType(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/registration`,
      data
    );
  }
  deleteRegistrationType(registrationId: any) {
    return this.http.delete(
      environment.baseUrl +
        `admin/master/business/registration?id=${registrationId}`
    );
  }

  //merged industries and subindustries api
  mergedIndustrySubIndustry() {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/sub?size=1000&page=0`
    );
  }
  businessRegistrationFilter(status: any, pageNo: any, size: any) {
    return this.http.put(
      environment.baseUrl +
        `admin/master/business/registration/filter?active=${status}&pageNo=${pageNo}&size=${size}`,
      {}
    );
  }
  setBlogData(body: any) {
    localStorage.setItem('blogData', JSON.stringify(body));
  }

  getBlogData() {
    let blogData: any = '';
    if (localStorage.getItem('blogData')) {
      blogData = JSON.parse(localStorage.getItem('blogData') || '');
    } else {
      blogData = '';
    }

    return blogData;
  }

  updateBlog(data: any) {
    return this.http.put(environment.baseUrl + `business/blog/update`, data);
  }

  filterDialog(
    componentName: any,
    panelClass: any,
    height: any,
    width: any,
    position: any,
    data: any
  ) {
    return this.dialog.open(componentName, {
      panelClass: panelClass,
      width: width,
      height: height,
      position: position,
      data: data,
      disableClose: true,
    });
  }

  UpdateMasterBlog(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/blog/master/update`,
      data
    );
  }

  getBlogsTagsByBusinessId(businessId: any) {
    return this.http.get(
      environment.baseUrl + `business/blog/getAll/tags/${businessId}`
    );
  }

  getAllBlogAuthors(businessId: any) {
    return this.http.get(
      environment.baseUrl + `business/blog/getAll/authors/${businessId}`
    );
  }

  getAllAuthors() {
    return this.http.get(environment.baseUrl + `admin/blog/getAll/authors`);
  }

  createMasterBlog(data: any) {
    return this.http.post(environment.baseUrl + `admin/blog/create`, data);
  }
  getMasterBlog() {
    return this.http.get(environment.baseUrl + `admin/blog/get/master`);
  }
  getMasterBlogsBySubIndustry(subIndustryId: any) {
    return this.http.get(
      environment.baseUrl + `admin/blog/getBlog/${subIndustryId}`
    );
  }

  addNewApp(data: any) {
    return this.http.post(environment.baseUrl + `admin/master/apps`, data);
  }

  getApps(data: any) {
    return this.http.get(
      environment.baseUrl + `app/app/list`,
      data
    );
  }
    getSubApps(data:any) {
    return this.http.get(
      environment.baseUrl + `app/app/list/sub-app`
    )
  }
     createSubApp(payload) {
    return this.http.post(
      environment.baseUrl + `app/app/create/sub-apps`, payload
    )
  }

getParentApps() {
  return this.http.get(environment.baseUrl + `app/app/list`);
}

  searchApp(request:any){
    return this.http.get(
      environment.baseUrl + `app/app/list/search?request=${request}`
    )
  }
  
  searchSubApp(request:any){
    return this.http.get(
      environment.baseUrl + `app/app/list/sub-app/search?request=${request}`
    )
  }
  addApp(data: any){
    return this.http.post(
      environment.serverIp + `master/apps`, data
    )
  }
  deleteApp(id: any) {
    return this.http.delete(
      environment.serverIp + `master/apps/${id}`
    );
  }
  addBusinessFunction(data: any){
    return this.http.post(
      environment.serverIp + `master/apps/business/function`, data
    )
  }
  getBusinessFunctionData(){
    return this.http.get(
      environment.serverIp + `master/apps/get/function`
    );
  }
  deleteBusinessFunction(functionId: any) {
    return this.http.delete(
      environment.serverIp + `master/apps/delete/function?functionId=${functionId}`
    );
  }

  getDefaultApps(){
    return this.http.get(
      environment.baseUrl + `app/app/list/default-app`
    );
  }
  
}
